import axios from "axios";
import {
	AuditCalendar,
	AuditCalendarPayload,
	AuditCalendarStats,
} from "../types/auditCalendar.type";

const API_URL = import.meta.env.VITE_APP_API_URL;

export const fetchAuditCalendars = async (
	schemeId?: number | string,
	districtId?: number | string,
	search?: string,
): Promise<AuditCalendar[]> => {
	const params = new URLSearchParams();
	params.append("limit", "1000");
	if (schemeId) params.append("scheme_id", String(schemeId));
	if (districtId) params.append("district_id", String(districtId));
	if (search) params.append("search", search);

	const response = await axios.get(
		`${API_URL}/admin/audit-calendar/list?${params.toString()}`,
	);
	const resData = response.data?.data;
	if (Array.isArray(resData)) return resData;
	if (resData && Array.isArray(resData.items)) return resData.items;
	return [];
};

export const fetchAuditCalendarStats = async (
	schemeId?: number | string,
	districtId?: number | string,
): Promise<AuditCalendarStats> => {
	const params = new URLSearchParams();
	if (schemeId) params.append("scheme_id", String(schemeId));
	if (districtId) params.append("district_id", String(districtId));

	const response = await axios.get(
		`${API_URL}/admin/audit-calendar/stats?${params.toString()}`,
	);
	return (
		response.data?.data || {
			totalPlanned: 0,
			completedAudits: 0,
			auditingThisWeek: 0,
			uploadedInMis: 0,
			nirnayYes: 0,
		}
	);
};

export const createAuditCalendar = async (
	payload: AuditCalendarPayload,
): Promise<any> => {
	const response = await axios.post(
		`${API_URL}/admin/audit-calendar/add`,
		payload,
	);
	return response.data;
};

export const updateAuditCalendar = async (
	id: number | string,
	payload: Partial<AuditCalendarPayload>,
): Promise<any> => {
	const response = await axios.put(
		`${API_URL}/admin/audit-calendar/edit/${id}`,
		payload,
	);
	return response.data;
};

export const deleteAuditCalendar = async (
	id: number | string,
): Promise<any> => {
	const response = await axios.delete(
		`${API_URL}/admin/audit-calendar/delete/${id}`,
	);
	return response.data;
};

export interface SchoolCategory {
	id: number;
	name: string;
}

export const fetchSchoolCategories = async (): Promise<SchoolCategory[]> => {
	const response = await axios.get(`${API_URL}/admin/school-category/list`);
	return response.data?.data || [];
};

export interface InstituteOption {
	id: number;
	name: string;
}

export const fetchInstitutesByDistrict = async (
	districtId: number | string,
): Promise<InstituteOption[]> => {
	const response = await axios.get(
		`${API_URL}/admin/institute/by-district/${districtId}`,
	);
	return response.data?.data || [];
};
